var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("确认") + _vm.$t("投保信息"),
      visible: _vm.visible,
      width: 400
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form", {
    attrs: {
      form: _vm.form,
      "label-col": {
        span: 8
      },
      "wrapper-col": {
        span: 12
      }
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("产品名称")
    }
  }, [_vm._v(" " + _vm._s(_vm.form.customerInsuranceName || "-") + " ")]), _c("a-form-item", {
    attrs: {
      label: _vm.$t("投保份数")
    }
  }, [_vm._v(" " + _vm._s(_vm.form.insureCount || "-") + " ")]), _c("a-form-item", {
    attrs: {
      label: _vm.$t("合计保费")
    }
  }, [_vm._v(" " + _vm._s(_vm.form.totalAmount || _vm.form.totalAmount === 0 ? _vm.form.totalAmount + " " + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId)) : "-") + " ")]), _c("a-form-item", {
    attrs: {
      label: _vm.$t("应付保费")
    }
  }, [_vm._v(" " + _vm._s(_vm.form.totalAmount || _vm.form.totalAmount === 0 ? _vm.form.totalActualAmount + " " + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId)) : "-") + " ")])], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.toPay
    }
  }, [_vm._v(_vm._s(_vm.$t("去支付")))])], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };